/* Lumoss - panier lateral */
(function () {
  var root = document.getElementById('cart-drawer');
  if (!root) return;

  var base = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var lastFocus = null;

  function count() { return parseInt(root.getAttribute('data-count'), 10) || 0; }

  function open() {
    lastFocus = document.activeElement;
    root.classList.add('is-open');
    root.setAttribute('aria-hidden', 'false');
    document.body.classList.add('cd-lock');
    var x = root.querySelector('[data-cd-close]');
    if (x && x.focus) { try { x.focus(); } catch (e) {} }
  }

  function close() {
    root.classList.remove('is-open');
    root.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('cd-lock');
    if (lastFocus && lastFocus.focus) { try { lastFocus.focus(); } catch (e) {} }
  }

  function badge(n) {
    var nodes = document.querySelectorAll('[data-cart-count]');
    for (var i = 0; i < nodes.length; i++) {
      nodes[i].textContent = n;
      if (n > 0) { nodes[i].removeAttribute('hidden'); } else { nodes[i].setAttribute('hidden', ''); }
    }
  }

  function refresh() {
    return fetch(base + '?sections=cart-drawer', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (j) {
        var html = j['cart-drawer'];
        if (!html) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.getElementById('cart-drawer');
        if (!fresh) return;
        root.innerHTML = fresh.innerHTML;
        root.setAttribute('data-count', fresh.getAttribute('data-count') || '0');
        badge(count());
      });
  }

  function change(line, quantity) {
    root.classList.add('is-busy');
    return fetch(base + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ line: line, quantity: quantity })
    })
      .then(function () { return refresh(); })
      .catch(function () { window.location.href = base + 'cart'; })
      .then(function () { root.classList.remove('is-busy'); });
  }

  /* Ajout au panier sans quitter la page */
  document.addEventListener('submit', function (e) {
    var form = e.target && e.target.closest ? e.target.closest('form[action*="/cart/add"]') : null;
    if (!form) return;
    e.preventDefault();

    var btn = form.querySelector('[type="submit"]');
    var label = btn ? btn.innerHTML : '';
    if (btn) { btn.disabled = true; btn.innerHTML = 'Ajout en cours'; }

    fetch(base + 'cart/add.js', { method: 'POST', body: new FormData(form) })
      .then(function (r) {
        if (!r.ok) throw new Error('add');
        return refresh();
      })
      .then(function () {
        if (btn) { btn.disabled = false; btn.innerHTML = label; }
        open();
      })
      .catch(function () {
        if (btn) { btn.disabled = false; btn.innerHTML = label; }
        form.removeAttribute('data-ajax');
        window.location.href = base + 'cart';
      });
  });

  /* Clics dans le tiroir et sur l'icone panier */
  document.addEventListener('click', function (e) {
    var el = e.target;
    if (!el || !el.closest) return;

    if (el.closest('[data-cd-close]')) { close(); return; }

    var opener = el.closest('[data-cd-open]');
    if (opener) { e.preventDefault(); open(); return; }

    var rm = el.closest('[data-cd-remove]');
    if (rm) {
      e.preventDefault();
      var lr = rm.closest('[data-line]');
      if (lr) change(parseInt(lr.getAttribute('data-line'), 10), 0);
      return;
    }

    var step = el.closest('[data-cd-step]');
    if (step) {
      var ls = step.closest('[data-line]');
      if (!ls) return;
      var cur = parseInt(ls.getAttribute('data-qty'), 10) || 1;
      var next = step.getAttribute('data-cd-step') === 'up' ? cur + 1 : cur - 1;
      if (next < 0) next = 0;
      change(parseInt(ls.getAttribute('data-line'), 10), next);
      return;
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && root.classList.contains('is-open')) close();
  });

  /* Survol de l'icone panier sur ordinateur, seulement si le panier contient quelque chose */
  var timer = null;
  var hoverable = window.matchMedia && window.matchMedia('(hover:hover)').matches;
  if (hoverable) {
    document.addEventListener('mouseover', function (e) {
      if (!e.target || !e.target.closest) return;
      if (!e.target.closest('[data-cd-open]')) return;
      if (count() < 1 || root.classList.contains('is-open')) return;
      clearTimeout(timer);
      timer = setTimeout(open, 400);
    });
    document.addEventListener('mouseout', function (e) {
      if (!e.target || !e.target.closest) return;
      if (e.target.closest('[data-cd-open]')) clearTimeout(timer);
    });
  }
})();